import { Vue, Component, Prop } from 'vue-property-decorator';
import { baseOptions, allEvents } from './config.codemirror';

import merge from 'lodash.merge';

@Component({
	mounted() {
		this.init();
	}
})
export default class CodeMirror extends Vue {
	editorId: string = '';

	baseOptions: object = baseOptions;

	cmInstance: CodeMirror.Editor | null = null;

	@Prop({
		default: ''
	})
	readonly code!: string;

	@Prop({
		default: () => {
			return {};
		}
	})
	readonly customOptions!: object;

	@Prop({
		default() {
			return [];
		}
	})
	readonly enabledEvents!: Array<string>;

	refresh(): void {
		this.$nextTick(() => {
			if (this.cmInstance) {
				this.cmInstance.refresh();
			}
		});
	}

	init(): void {
		this.editorId = `code-mirror-${this._uid}`;

		this.$nextTick().then(() => {
			const editorPaddingTopAndBottom = 12;

			this.cmInstance = window.CodeMirror.fromTextArea(
				<HTMLTextAreaElement>document.getElementById(this.editorId),
				merge({}, this.baseOptions, this.$props.customOptions)
			);

			this.cmInstance.setValue(this.$props.code);
			this.cmInstance.setSize(null, this.cmInstance.lineCount() * this.cmInstance.defaultTextHeight() + editorPaddingTopAndBottom);

			/**
			 * Binds events triggered from codeMirror, we want to listen
			 */
			allEvents
				.filter((evt) => this.enabledEvents.includes(evt))
				.forEach((evt) => {
					if (this.cmInstance) {
						this.cmInstance.on(evt, (...args) => {
							const currValue = this.cmInstance ? this.cmInstance.getValue() : null;

							this.$emit(evt, [...args, currValue]);
						});
					}
				});

			this.$emit('ready', this.cmInstance);
			this.$parent.$emit('component:loaded');
		});
	}
}
